import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import messages from '../documentMessages';

const RegistrationListDetail = ({ document }) => {
  if (!document.recognitionMeta) return null;
  const documentMeta =
    typeof document.recognitionMeta === 'string'
      ? JSON.parse(document.recognitionMeta)
      : document.recognitionMeta;

  return (
    <div className="margin10B">
      <div className="row">
        <div className="col-md-2">
          <FormattedMessage {...messages.AmountOfRegistrations} />
        </div>
        <label>{documentMeta.numberOfRegistrations}</label>
      </div>
      {documentMeta.ignoredColumns && (
        <div className="row">
          <div className="col-md-2">
            <FormattedMessage {...messages.IgnoredColumns} />
          </div>
          <label>{documentMeta.ignoredColumns.join(', ')}</label>
        </div>
      )}
    </div>
  );
};

RegistrationListDetail.propTypes = {
  document: PropTypes.shape({}).isRequired,
};

export default RegistrationListDetail;
